/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2020-11-18 08:51:11
 */
import Vue from 'vue'
import Router from 'vue-router'
import PersonInfo from '../views/PersonInfo.vue'
import DownloadAll from '../views/DownloadAll'
import CourseWareDetail from '../views/CourseWareDetail'
import TeachingReflection from '../views/teachingRelection.vue'
import Result from '../views/Result.vue'
import Login from '@/views/login/index.vue'
import Layout from '@/views/layout/index.vue'
import NotFound from '@/views/notFound.vue'
Vue.use(Router)

const router = new Router({
  'mode': 'history',
  routes: [
    {
      path: '/index',
      name: 'layout',
      component: Layout,
      children: [
        {
          path: '/PersonInfo',
          name: '个人信息',
          component: PersonInfo
        },
        {
          path: '/DownloadAll',
          name: '课件下载',
          component: DownloadAll
        },
        {
          path: '/:activityId/:playerId/CourseWareDetail',
          name: '展示课件',
          component: CourseWareDetail
        },
        {
          path: '/:activityId/:playerId/teachingReflection',
          name: 'teachingReflection',
          component: TeachingReflection
        },
        {
          path: '/Result',
          name: 'Result',
          component: Result
        }
      ]
    },
    {
      path: '/:id/:isReflection',
      name: 'reFlectionLogin',
      component: Login
    },
    {
      path: '/:id',
      name: 'login',
      component: Login
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js